import { ModelNoDates } from "@/types/types";

export const getModel = (
  id: string,
  models: ModelNoDates[]
): ModelNoDates | null => {
  const foundModel = models.find((model) => model.id === id);

  if (foundModel !== undefined) {
    return foundModel;
  }
  return null;
};
